export const locale = {
  lang: 'ru',
  data: {
    LOGIN: {
      // TITLE: "",
      // TIP: "",
      // FORGOT_PASSWORD: "",
      // REMEMBER: "",
      // SIGN_IN: "",
      // SIGN_UP_TIP: "",
      // SIGN_UP: "",
      // ERROR: ""
    },
    REGISTER: {
      // TITLE: "",
      // TIP: "",
      // AGREE: "",
      // AGREEMENT: "",
      // SIGN_UP: "",
      // SIGN_IN_TIP: "",
      // SIGN_IN: "",
    },
    FORGOT: {
    },
    RESET: {
    },
    FORM: {
      // FIRST_NAME: "",
      // LAST_NAME: "",
      // EMAIL: "",
      // PHONE: "",
      // PASSWORD: "",
      // CONFIRM_PASSWORD: "",
      // GENDER: "",
      // BIRTH_DATE: "",
      // COUNTRY: "",
      // STREET: "",
      // CITY: "",
      // POSTAL_CODE: "",
      // REQUIRED: ""
    },
    GENDER: {
      // MEN: "",
      // WOMEN: "",
      // OTHER: ""
    }
  }
}